import axiosClient from '../axiosClient';
import type { AxiosRequestConfig } from 'axios';

export interface DataViewAuditEvent {
  eventType: string;
  rowId: number;
  changeDate: string;
  userName: string;
  columnName?: string | null;
  oldValue?: string | null;
  newValue?: string | null;
  rowData?: Record<string, unknown> | null;
  /**
   * Bug 3703: a sentence written by the backend for a change whose raw values do not read as a
   * change on their own -- today that is a comment column, which keeps its whole thread in one
   * cell. Shown verbatim: the wording belongs to the backend, not to a table on this side.
   *
   * Additive. oldValue and newValue are untouched, because the undo action writes oldValue back
   * into the cell and would otherwise write this sentence into the row instead of the comments.
   */
  changeSummary?: string | null;
}

export async function getRowAudit (
  tableKey: string,
  rowId: number,
  signal?: AbortSignal
): Promise<DataViewAuditEvent[]> {
  const normalizedTableKey = String(tableKey || '').trim();
  if (!normalizedTableKey) {
    throw new Error('tableKey mangler');
  }
  const config: AxiosRequestConfig = {
    signal,
    params: { tableKey: normalizedTableKey, rowId }
  };
  const response = await axiosClient.get<DataViewAuditEvent[]>(
    'data-views/audit/row',
    config
  );
  return response.data ?? [];
}

export async function getDistinctAuditUsers (
  tableKey: string,
  signal?: AbortSignal
): Promise<string[]> {
  const normalizedTableKey = String(tableKey || '').trim();
  if (!normalizedTableKey) {
    throw new Error('tableKey mangler');
  }
  const config: AxiosRequestConfig = {
    signal,
    params: { tableKey: normalizedTableKey }
  };
  const response = await axiosClient.get<string[]>(
    'data-views/audit/distinct-users',
    config
  );
  return response.data ?? [];
}
